import { render, staticRenderFns } from "./AddressListItem.vue?vue&type=template&id=97968c3e&scoped=true&"
import script from "./AddressListItem.vue?vue&type=script&lang=ts&"
export * from "./AddressListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AddressListItem.vue?vue&type=style&index=0&id=97968c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97968c3e",
  null
  
)

export default component.exports